// eslint-disable-next-line
// @ts-nocheck
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Tab from '@mui/material/Tab';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListHead, BookingListToolbar, BookingMoreMenu } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getParkingSpaces, getParkingTotalRecords, setParkings } from '../../store/state/parkingSlice';
import { useGetAllParkingSpaceLocationMutation } from '../../store/api/parkingsApi';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Loading from '../../components/Loading';

const TABLE_HEAD = [
  { id: 'vendorName', label: 'Vendor Name', alignRight: false },
  { id: 'name', label: 'Model Name', alignRight: false },
  { id: 'reg. no', label: 'Reg. No', alignRight: false },
  { id: 'slots', label: 'Seating Capacity', alignRight: false },
  { id: 'address', label: 'Address', alignRight: false },
  { id: 'status', label: 'Vehicle Status', alignRight: false },
  { id: 'vendorStatus', label: "Vendor's Status", alignRight: false },
  { id: '' },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function NewParkingRequests() {
  const parkingSpacesData = useAppSelector(getParkingSpaces);
  const [getAllParkingSpaceLocation, getAllResponse] = useGetAllParkingSpaceLocationMutation();
  const [parkingSpaces, setParkingSpaces] = useState([]);
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [value, setValue] = useState(0);
  const totalParkingRequestRecords = useAppSelector(getParkingTotalRecords);
  const filteredUsers = parkingSpaces;
  const isUserNotFound = filteredUsers.length === 0;

  useEffect(() => {
    if (parkingSpacesData) {
      setParkingSpaces(parkingSpacesData);
    }
  }, [parkingSpacesData]);

  useEffect(() => {
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        currentStage: 'pending',
      },
    });
  }, []);

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setParkings(getAllResponse.data));
    }
    if (getAllResponse.isError) {
      let errorData: any = getAllResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllResponse.isSuccess, getAllResponse.isError]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = parkingSpaces.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: newPage,
        currentStage: 'pending',
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: parseInt(event.target.value, 10),
        page: 0,
        currentStage: 'pending',
      },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    dispatch(
      getAllParkingSpaceLocation({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          name: event.target.value,
          currentStage: 'pending',
        },
      })
    );
  };

  return (
    <Page title="Vehicle Status">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Vehicle Request
          </Typography>
          <Button
            variant="contained"
            style={{ color: 'white', backgroundColor: '#E23744' }}
            onClick={() => {
              navigate('/dashboard/all-vehicle-spaces', { replace: true });
            }}
            sx={{ marginBottom: '10px' }}
            size="medium"
          >
            <ArrowBackIcon />
          </Button>
        </Stack>
        <Card>
          <BookingListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder={'Search By Modal Name'}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={parkingSpaces.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const {
                        id,
                        name,
                        role,
                        currentStatus,
                        company,
                        avatarUrl,
                        isVerified,
                        serviceProviderDetailResponseDTO,
                        vehicleDetailObj,
                        address
                      } = row;
                      const isItemSelected = selected.indexOf(vehicleDetailObj?.model) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell
                            onClick={() => {
                              navigate('/dashboard/addvehicle', {
                                state: { isApprove: true, id: id },
                              });
                            }}
                            align="left"
                            style={{
                              color: serviceProviderDetailResponseDTO.currentStatus !== 'Approved' ? 'red' : 'black',
                              fontSize: 'bold',
                            }}
                          >
                            {serviceProviderDetailResponseDTO?.vendorAlias}
                          </TableCell>

                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Button
                                onClick={() => {
                                  navigate('/dashboard/addvehicle', {
                                    state: { isApprove: true, id: id },
                                  });
                                }}
                                disabled={serviceProviderDetailResponseDTO.currentStatus !== 'Approved' ? true : false}
                              >
                                <Typography variant="subtitle2" noWrap>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: vehicleDetailObj?.model === null ? 'No Model Name Available' : vehicleDetailObj?.model,
                                    }}
                                  />
                                </Typography>
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                              <Typography variant="body2">{vehicleDetailObj?.registrationNumber}</Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography
                                variant="body2"
                              >
                                {vehicleDetailObj?.seatingCapacity}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="body2">{address}</Typography>
                            </TableCell>
                          <TableCell align="left">
                            <Label variant="ghost" color={(currentStatus === 'pending' && 'error') || 'success'}>
                              {sentenceCase(currentStatus === 'pending' ? 'Pending' : 'Approved')}
                            </Label>
                          </TableCell>
                          <TableCell align="left">
                            <Label
                              variant="ghost"
                              color={
                                (serviceProviderDetailResponseDTO.currentStatus !== 'Approved' && 'error') || 'success'
                              }
                            >
                              {serviceProviderDetailResponseDTO.currentStatus !== 'Approved' ? 'InActive' : 'Active'}
                            </Label>
                          </TableCell>

                          <TableCell align="right"></TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalParkingRequestRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {getAllResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
